import { Col, Row, Button } from 'antd';
import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TUser from './Tables/TUser';
import { AppState } from 'src/store';
import { connect } from 'react-redux';
import { UserState } from 'src/store/user/types';
import TPcg from './Tables/TPcg';
interface UsersProps {
    user: UserState;
}

const Users: React.FC<UsersProps> = (props: UsersProps) => {
    return (
        <div>
            <AdminHeader>Usuarios</AdminHeader>
            <TUser  validatePortfolio={false} />            
        </div>

    );
};


const mapStateToProps = (state: AppState) => ({
    user: state.user
});
export default connect(mapStateToProps, {
})(Users);